<template>
  <div>
    <!--头部-->
    <HeaderForBeauty :showValue="2"></HeaderForBeauty>
    <!--banner end-->
    <div class="jqgk" style="background: rgba(227, 227, 227, 0.84)">
      <div class="contai"  style="max-width: 1197px; padding-left: 20px; padding-right: 20px">
        <div class="top_tit" :style="pcshow?'margin-top: 50px':'margin-top: 20px'">
          <div class="onlylunbotu">
            <div class="back_add">

              <!-- <div class="threeImg" v-if="pcshow">
                <div class="Containt">
                  <div class="iconleft" @click="zuohua">
                    <a-icon type="left" />
                  </div>
                  <ul
                    :style="{ left: calleft + 'px',width: ulwidth + 'px' }"
                    v-on:mouseover="stopmove()"
                    v-on:mouseout="move()"
                  >
                    <li
                      v-for="item in listCaiDan"
                      :key="item.id"
                      class="imgclass"
                      style="font-size: 16px; color: rgb(132, 2, 7)"
                      @click="openvideo(item)"
                    >
                      {{ item.title }}
                      <img :src="item.cover" />
                    </li>
                  </ul>
                  <div class="iconright" @click="youhua">
                    <a-icon type="right" />
                  </div>
                </div>
              </div> -->
              <span v-if="pcshow"  style="width:100%;color:rgb(132, 2, 7);font-size:20px;margin:10px auto">{{title}}</span>
              <div  v-if="pcshow" style="height:450px">

                 <el-carousel
                :interval="4000"
                type="card"
                height="400px"
                v-if="pcshow"
                @change='change'
              >
                <el-carousel-item v-for="item in listCaiDan" :key="item.id">
                  <!-- <span style="background-color:rgba(227, 227, 227, 0.84);width:100%;color:rgb(132, 2, 7)">{{item.title}}</span> -->
                  <img
                    :src="item.cover  "
                    style="width:100%;height:400px"
                    @click="openvideo(item)"
                  />
                </el-carousel-item>
              </el-carousel>
              </div>

               <div  v-if="!pcshow" style="height:18vh">
                 <el-carousel
                :interval="4000"
                type="card"
                height="18vh"
                v-if="!pcshow"
              >
                <el-carousel-item v-for="item in listCaiDan" :key="item.id">
                  <span style="background-color:rgb(236 236 236 / 84%);width:100%;color:rgb(132, 2, 7)">{{item.title}}</span>
                  <img
                    :src="item.cover  "
                    style="width:100%;height:18vh"
                    @click="openvideo(item)"
                  />
                </el-carousel-item>
              </el-carousel>
              </div>

            </div>
          </div>

          <a-modal
            :visible="videoShow"
            @ok="handleOk"
            @cancel="handleCancel"
            :width="1000"
          >
            <div class="beautyTop">
              <p style="color: #840207">{{ titleModal }}</p>
              <div class="travel_con">
                <video-player
                  class="video-player vjs-custom-skin"
                  style="height: 100%"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                  @play="onPlayerPlay($event)"
                ></video-player>
              </div>
            </div>
          </a-modal>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import { getcnBeautyVideo } from '@/api/public'
import HeaderForBeauty from './headerforbeauty'
import Footer from './footer'
export default {
  components: { HeaderForBeauty, Footer },
  data () {
    return {
      calleft: 0,
      ulwidth: 2000,
      videoShow: false,
      style: 'height:140px;width:200px',
      choseValue: 1,
      pcshow: false,
      styletable: {},
      mapStyle: {
        color: '#840207',
        background:
          'linear-gradient(270deg, rgba(132, 2, 7, 0.29), rgba(132, 2, 7, 0))'
      },
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: '', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: '' // url地址 ？？暂时无可用 http://gangmao.oss-cn-shenzhen.aliyuncs.com/qiaoxishan/%E7%99%BD%E4%BA%91%E6%B4%9E.mp4
          }
        ],
        poster: '', // 你的封面地址  ？？暂时无可用 http://gangmao.oss-cn-shenzhen.aliyuncs.com/qiaoxishan/fenmian.png
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      dataList: [],
      listCaiDan: [],
      title: '',
      chooseValue: 1,
      titleModal: ''
    }
  },
  beforeCreate () {},
  created () {
    this.move()
    if (this._isMobile()) {
      this.pcshow = false
    } else {
      this.pcshow = true
    }
  },

  mounted () {
    this.init1()
    this.getLocation()
  },
  computed: {},
  methods: {
    change (index) {
      this.title = this.listCaiDan[index].title
    },
    // 移动
    move () {
      // this.timer = setInterval(this.starmove, 2500);
    },
    // 开始移动
    starmove () {
      if (this.listCaiDan.length > 3) {
        this.calleft -= 340
        // ulwidth 3600
        if (this.calleft < -this.ulwidth) {
          this.calleft = 0
        }
      }
    },
    // 鼠标悬停时停止移动
    stopmove () {
      clearInterval(this.timer)
    },
    // 点击按钮左移
    zuohua () {
      if (this.listCaiDan.length > 3) {
        this.calleft -= 340
        if (this.calleft < -(this.ulwidth - 1020)) {
          this.calleft = 0
        }
      }
    },
    // 点击按钮右移
    youhua () {
      if (this.listCaiDan.length > 3) {
        this.calleft += 340
        if (this.calleft > 0) {
          this.calleft = -(this.ulwidth - 1020)
        }
      }
    },
    handleOk () {
      this.videoShow = false
    },
    handleCancel () {
      this.videoShow = false
    },
    openvideo (item) {
      this.videoShow = true
      this.playerOptions.sources[0].src = item.url
      this.playerOptions.poster = item.cover
      this.title = item.title
      this.titleModal = item.title
    },
    changeBig () {
      this.style = 'height:240px;width:220px'
    },
    // 选择菜单
    chooseTab (info) {
      this.title = info.title
      this.getLocation()
    },
    // 判断是PC端还是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    // 初始化工作
    init1 () {
      getcnBeautyVideo(this.title).then((response) => {
        this.listCaiDan = response.data
        //         this.listCaiDan = [
        //           {id: 7, title: "天湖公园", cover: "http://gangmao.oss-cn-shenzhen.aliyuncs.com/fzydd/20210402/天湖公园.jpg",
        // sort: 11,
        // title: "天湖公园"},
        //  {id: 217, title: "天湖公园", cover: "http://gangmao.oss-cn-shenzhen.aliyuncs.com/fzydd/20210402/天湖公园.jpg",
        // sort: 11,
        // title: "天湖公园"},
        //  {id: 317, title: "天湖公园", cover: "http://gangmao.oss-cn-shenzhen.aliyuncs.com/fzydd/20210402/天湖公园.jpg",
        // sort: 11,
        // title: "天湖公园"},
        //  {id: 417, title: "天湖公园", cover: "http://gangmao.oss-cn-shenzhen.aliyuncs.com/fzydd/20210402/天湖公园.jpg",
        // sort: 11,
        // title: "天湖公园"}
        //         ]
        // response.data.length
        this.ulwidth = (this.listCaiDan.length) * 340
        this.listCaiDan.length > 0
          ? ((this.chooseValue = this.listCaiDan[0].id),
          (this.title = this.listCaiDan[0].title))
          : ''
        this.init2()
      })
    },
    // 初始化内容获取
    init2 () {
      getcnBeautyVideo(this.title).then((response) => {
        this.playerOptions.sources[0].src = response.data[0].url
        // this.$refs.videoPlayer.player.play();
      })
    },
    getLocation () {
      getcnBeautyVideo(this.title).then((response) => {
        this.playerOptions.sources[0].src = response.data[0].url
        // console.log("1", this.playerOptions.sources[0].src)
        // console.log("2")
        // that.$refs.videoPlayer.player.play()
        // console.log("3")
      })
    },
    // 播放
    onPlayerPlay (player) {
      console.log('player play!', player)
      const myPlayer = this.$refs.videoPlayer.player
      myPlayer.play()
    },
    // 菜单选择
    tabSelect (e) {
      let value = e.target.dataset.index
      this.choseValue = value
    },
    // 详情()
    seeInfo (infoid) {
      this.$router.push({
        path: '/sceneryInfo',
        query: {
          id: infoid
        }
      })
    }
  }
}
</script>

<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.vjs-poster{
  background-color: #fff !important;
}
.onlylunbotu #divAdd {
  background-color: #ededed;
  /*width: 100%;*/
  /*min-width: 1200px;*/
  width: 1000px;
  margin: 0px auto;
}

.divAdd-con {
  margin: 0px auto;
  width: 1000px;
  overflow: auto;
  padding: 30px 0px;
}

.onlylunbotu .divAdd-con img {
  float: left;
}

.indexrt {
  margin: 0px 40px;
}

.onlylunbotu .divAddleft img {
  float: left;
  margin-bottom: 7px;
}

.divAddleft {
  float: left;
  display: inline;
  width: 370px;
}

.divAddrt {
  float: right;
  display: inline;
  margin-top: 7px;
}

.back_add {
  background-color: #ededed;
}

.onlylunbotu .divAdd-con img {
  border: none;
}

.onlylunbotu a:focus,
.onlylunbotu a:hover {
  color: #23527c;
}

.threeImg {
  height: 300px;
  background: #ededed;
  /* border-bottom: 3px solid #4679B2; */
  min-width: 1000px;
  padding-top: 5px;
}

.onlylunbotu .threeImg .Containt ul {
  margin: 0 auto;
  width: 2000px;
  position: absolute;
  left: 0px;
  cursor: pointer;
  height: 100%;
}

.onlylunbotu .threeImg .Containt ul li {
  width: 300px;
  margin-right: 40px;
  margin-top: 20px;
  float: left;
  padding-left: 20px;
}

.onlylunbotu .threeImg .Containt ul li img {
  height: 200px;
  width: 100%;
  margin-bottom: 20px;
}

.Containt {
  position: relative;
  width: 1000px;
  height: 250px;
  overflow: hidden;
  margin: 0 auto;
}

.iconleft {
  position: absolute;
  width: 20px;
  height: 110px;
  top: 90px;
  z-index: 999;
  padding-top: 48px;
  background-color: #e6e0d2bf;
  vertical-align: middle;
}

.iconright {
  position: relative;
  left: 980px;
  top: 70px;
  background-color: #ddd;
  /*position: absolute;*/
  width: 20px;
  height: 110px;
  top: 90px;
  z-index: 999;
  padding-top: 48px;
  background-color: #e6e0d2bf;
  vertical-align: middle;
}

.imgclass:hover {
  /* width: 300px;
      height: 300px; */
  transform: scale(1.4);
}
/* 轮播背景图 */
.slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  /* background: #364d79; */
  overflow: hidden;
}
.custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}
.custom-slick-arrow:before {
  display: none;
}
.custom-slick-arrow:hover {
  opacity: 0.5;
}

.slick-slide div {
  color: #fff;
}

.titleShuXian {
  height: 48px;
  margin-top: 9px;
  width: 8px;
  background-color: #840207;
  float: left;
}
.titleFontEnglish {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 10px;
  padding-bottom: 15px;
}
.tra_tab {
  font-size: 28px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  width: 193px;
  height: 67px;
  text-align: center;
  line-height: 67px;
  cursor: pointer;
}
.tra_tab_mobile {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  padding: 10px;
}
.tra_tab_line_mobile {
  display: block;
  width: 100%;
  height: 2px;
  background: #840207;
  opacity: 0.1;
}
.tra_tab_line {
  display: block;
  width: 100%;
  height: 8px;
  background: #840207;
  opacity: 0.1;
}
.titleFontFortitle {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #840207;
  line-height: 36px;
  float: left;
  padding: 15px;
}
.sceneryImgSize {
  /* width: 542px;
  height: 359px; */
  /* width: 250px; */
  padding-right: 5px;
  height: 200px;
}
.sceneryFontSize {
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: black;
  width: 270px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}
.showPicture {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}
.sceneryDescFontSize {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  padding: 0 20px;
  margin-bottom: 20px;
  width: 270px;
  height: 60px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.sceneryBtn {
  font-size: 18px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #ffffff;
  width: 126px;
  height: 44px;
  background: #840207;
  border: none;
  margin: 25px 0px 50px;
}

.beautytab {
  white-space: nowrap;
  line-height: 1.466666666666667rem;
  font-size: 0.7rem;
  overflow-y: hidden;
  padding-top: 10px;
}
.beautytab .table-item {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: inline-block;
}
.beautytab .table-button {
  min-width: 61px;
  height: 30px;
  border-radius: 4px;
  background: #840207;
  border-radius: 4px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #fff5e0;
  cursor: pointer;
}
.beautyTop {
  text-align: left;
  padding: 10px ;
  background-color: #fff;
  margin-top: 20px;
}
.beautytabFont {
  color: black;
  font-size: 16px;
  padding-top: 5px;
}
.beautyLayout {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  text-align: center;
}

 @media all and (min-width:500px) and (max-width:100000px){
   .el-carousel__arrow{
  font-size: 55px !important;
      height: 60px  !important;
    width: 60px  !important;
}
 }

</style>



// WEBPACK FOOTER //
// src/components/BeautyAllOverForMove.vue